import {usePermission} from '../../core/PermissionContext';
import {UserPermission, CompanyPermission} from '../../utils/utils';

const SHORTCUT_DEFINITIONS = [
    {
        key: 'pdv-table',
        label: 'Pedido Mesa',
        path: '/pdv/table',
        companyPermission: CompanyPermission.PDV_MODULE,
        userPermission: UserPermission.PDV_VIEW,
    },
    {
        key: 'pdv-items',
        label: 'Pedido Balcão',
        path: '/pdv/items',
        companyPermission: CompanyPermission.PDV_MODULE,
        userPermission: UserPermission.PDV_MANAGE,
    },
    {
        key: 'pdv-pending',
        label: 'Fechar Comanda',
        path: '/pdv/pending',
        companyPermission: CompanyPermission.PDV_MODULE,
        userPermission: UserPermission.PDV_MANAGE,
    },
    {
        key: 'pdv-sales',
        label: 'Consultar Pedidos',
        path: '/pdv/sales',
        companyPermission: CompanyPermission.PDV_MODULE,
        userPermission: UserPermission.PDV_MANAGE,
    },
    {
        key: 'qr-login',
        label: 'Garçom · QR Code',
        action: 'qr-invite',
        companyPermission: CompanyPermission.QR_LOGIN_MODULE,
        userPermission: UserPermission.EDIT_USER,
    },
];

export function useHomeShortcuts() {
    const {hasUserPermission, hasCompanyPermission} = usePermission();

    const enabled =
        hasCompanyPermission(CompanyPermission.SHOW_HOME_SHORTCUTS) &&
        hasUserPermission(UserPermission.SHOW_HOME_SHORTCUTS);

    const items = enabled
        ? SHORTCUT_DEFINITIONS.filter(item =>
            hasCompanyPermission(item.companyPermission) && hasUserPermission(item.userPermission))
        : [];

    return {items};
}
